import TextField from "@mui/material/TextField";
import React from "react";

const FormikTextField = ({ form, field, error, color, ...rest }) => {
  console.log("Form", form, rest);
  error = "";
  if (form.errors[field.name] && form.touched[field.name]) {
    console.log("Error", form.errors, form.touched);
    error = form.errors[field.name];
  }
  if (!color) {
    color = "secondary";
  }

  return (
    <TextField
      margin="normal"
      fullWidth={true}
      color={color}
      error={!!error}
      helperText={error}
      {...field}
      {...rest}
    />
  );
};

export default FormikTextField;
